import React from "react";
import { Box } from "@mui/material";
import { FONT_SIZE } from "../../../../constants/fontSizes";

/**
 * 使用技術（スキル）
 * 表示ルール：
 * ■ カテゴリー
 * メインスキル
 * ・サブスキル
 */
export default function SkillSheetMainSkill({ skillSections }) {
  const sections = Array.isArray(skillSections) ? skillSections : [];

  // 未入力の場合は - を表示
  if (sections.length === 0) {
    return <Box sx={{ p: 0.5, fontSize: FONT_SIZE.XXS }}>-</Box>;
  }

  return (
    <Box sx={{ px: 0.5, mt: -0.5 }}>
      {sections
        .filter(
          (section) =>
            Array.isArray(section.skills) &&
            section.skills.some(
              (skill) =>
                typeof skill.name === "string" && skill.name.trim() !== "",
            ),
        )
        .map((section, sectionIdx) => (
          <Box key={sectionIdx} sx={{ mb: 0.5 }}>
            {/* ■ カテゴリー */}
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 0.5,
                borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              }}
            >
              <Box sx={{ fontSize: FONT_SIZE.XXS, fontWeight: 700 }}>■</Box>
              <Box sx={{ fontSize: FONT_SIZE.XXS, fontWeight: 700 }}>
                {section.category}
              </Box>
            </Box>

            {/* メインスキル */}
            {section.skills
              .filter(
                (skill) =>
                  typeof skill.name === "string" && skill.name.trim() !== "",
              )
              .map((skill, skillIdx) => (
                <Box key={skillIdx}>
                  {/* メインスキル名 */}
                  <Box sx={{ fontSize: "0.65rem" }}>{skill.name}</Box>

                  {/* サブスキル */}
                  {(skill.subSkills || []).length > 0 && (
                    <Box
                      component="ul"
                      sx={{ m: 0, pl: 2, listStyleType: "disc" }}
                    >
                      {skill.subSkills.map((sub, subIdx) => (
                        <Box
                          key={subIdx}
                          component="li"
                          sx={{
                            fontSize: FONT_SIZE.XXS,
                            lineHeight: 1.7,
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {sub}
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              ))}
          </Box>
        ))}
    </Box>
  );
}
